const USER_ATTRIBUTES = 'forecasting-early-request-user-attributes';
const HUBS_SETTINGS = 'forecasting-early-request';
const USERS = 'forecasting-early-request-users';
const OWNERS = 'forecasting-early-request-owners';
const CURRENCIES = 'forecasting-early-request-currencies';
const DEALS_WITH_FORECAST_CATEGORIES = 'forecasting-early-request-deals-with-forecast-categories';
const FORECAST_TYPES = 'forecast-eary-request-forecast-types';
const PIPELINES = 'forecasting-early-request-pipelines';
const PREFERRED_CURRENCY = 'forecasting-early-request-preferred-currency';
const PROCESSING_DEALS_STATUS = 'forecasting-early-request-processing-deals-status';
const PORTAL_CONFIGURATION = 'forecasting-early-request-portal-configuration';
const PORTAL_CADENCE = 'forecasting-early-request-portal-cadence';
const PORTAL_FMO_ADMIN_ONBOARDING = 'forecasting-early-request-portal-fmo-admin-onboarding';
const AI_PROJECTIONS_OPT_IN = 'forecasting-early-request-ai-projections-opt-in';
const TEAMS = 'forecasting-early-request-teams';
export const EARLY_REQUESTER_KEYS = {
  AI_PROJECTIONS_OPT_IN,
  CURRENCIES,
  DEALS_WITH_FORECAST_CATEGORIES,
  FORECAST_TYPES,
  HUBS_SETTINGS,
  OWNERS,
  PIPELINES,
  PORTAL_FMO_ADMIN_ONBOARDING,
  PORTAL_CADENCE,
  PORTAL_CONFIGURATION,
  PREFERRED_CURRENCY,
  PROCESSING_DEALS_STATUS,
  TEAMS,
  USER_ATTRIBUTES,
  USERS
};